import React from "react";
import { View, Text, StyleSheet, Platform } from "react-native";

import ManaButton from "../../common/ManaButton";
import IntegrationsHelper from "../IntegrationsHelper";

export default function ReconnectIfOld({
  account,
  connected,
  controller,
  integrationType,
  lastUpdated,
  reconnect,
}) {
  const onButtonPress = () => {
    if (typeof reconnect == "function") return reconnect();

    IntegrationsHelper.reconnect(controller, integrationType, account);
  };

  return IntegrationsHelper.isOldIntegration(connected, lastUpdated) ? (
    <>
      <Text style={[styles.linkText, { marginTop: 16 }]}>
        We’re having trouble connecting to your account
      </Text>
      <View
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 16,
          marginTop: 8,
        }}
      >
        <ManaButton
          isMainButton
          onPress={onButtonPress}
          text="Reconnect"
          style={styles.button}
          styleText={styles.buttonText}
        />
      </View>
    </>
  ) : null;
}

const styles = StyleSheet.create({
  linkText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: "#DD5F43",
    width: "100%",
    textAlign: "center",
    marginTop: 32,
  },
  button: {
    width: 183,
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
